import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

export default class SectionsInclusionsEdit {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    const submitTurboPatch = (url) => {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = url;
      form.setAttribute('data-turbo', 'true');

      const methodInput = document.createElement('input');
      methodInput.type = 'hidden';
      methodInput.name = '_method';
      methodInput.value = 'patch';
      form.appendChild(methodInput);

      const csrfToken = $('meta[name="csrf-token"]').attr('content');
      if (csrfToken) {
        const tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = 'authenticity_token';
        tokenInput.value = csrfToken;
        form.appendChild(tokenInput);
      }

      document.body.appendChild(form);
      form.requestSubmit();
      form.remove();
    };

    const updateLabel = (input, layout) => {
      $(input)
        .closest('.custom-control')
        .find('.custom-control-label .font-weight-light')
        .text(layout === 'expanded' ? 'Expanded' : 'Compact');
    };

    $('#expandAllLayouts').on('change', function() {
      if (!accountUrl) {
        return;
      }

      const layout = $(this).is(':checked') ? 'expanded' : 'compact';
      const dashboardId = $(this).attr('data-dashboard-id');
      const reportId = $(this).attr('data-report-id');

      const params = { layout: layout };
      if (dashboardId) {
        params.dashboard_id = dashboardId;
      }
      if (reportId) {
        params.report_id = reportId;
      }

      const url = '/' + accountUrl + '/sections/inclusions/update_all_layout?' + $.param(params);
      submitTurboPatch(url);
    });      

    $('.custom-control-input[data-inclusion-id]').on('change', function() {
      const input = this;
      const inclusionId = $(this).data('inclusion-id');
      if (!accountUrl || !inclusionId) {
        return;
      }

      const previousLayout = input.checked ? 'compact' : 'expanded';
      const layout = input.checked ? 'expanded' : 'compact';
      const url = '/' + accountUrl + '/sections/inclusions/' + inclusionId + '.json?';
      const params = { section_inclusion: { layout: layout } };

      updateLabel(input, layout);

      $.ajax({
        type: 'PATCH',
        dataType: 'json',
        url: url + $.param(params),
        beforeSend: function(xhr) {
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        success: function(data) {
          if (data && data.layout) {
            updateLabel(input, data.layout);
          }
        },
        error: function() {
          input.checked = !input.checked;
          updateLabel(input, previousLayout);
          ToastCustom({
            title: 'Update failed',
            message: 'Could not save layout changes. Please try again.',
            delay: 5000,
            type: 'warning'
          });
        }
      });
    });
  }

}
